import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaArrowLeft, FaHome, FaBuilding, FaPlus, FaEdit, FaTrash } from 'react-icons/fa';

const SavedAddresses = () => {
  const [addresses, setAddresses] = useState([
    { id: 1, type: 'Home', address: 'Kalyan City, West Bengal, 712502', phone: '+91 98765 43210', default: true },
    { id: 2, type: 'Office', address: 'Tech Park, Sector V, Kolkata, 700091', phone: '+91 98765 43211', default: false },
    { id: 3, type: 'Other', address: 'Green Valley Apartment, Mumbai, 400001', phone: '+91 98765 43212', default: false },
  ]);

  const [showAddForm, setShowAddForm] = useState(false);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this address?')) {
      setAddresses(addresses.filter(addr => addr.id !== id));
    }
  };

  return (
    <motion.div 
      className="py-4 max-w-2xl mx-auto"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className="page-header">
        <Link to="/profile" className="back-btn">
          <FaArrowLeft /> Back
        </Link>
        <h1 className="page-title">📍 Saved Addresses</h1>
      </div>

      <button
        onClick={() => setShowAddForm(!showAddForm)}
        className="w-full mb-6 py-3 px-4 rounded-xl border-2 border-dashed border-primary text-primary font-semibold hover:bg-primary hover:text-white transition-all duration-300 flex items-center justify-center gap-2"
      >
        <FaPlus /> Add New Address
      </button>

      {showAddForm && (
        <div className="card mb-6">
          <h3 className="font-bold text-[var(--text)] mb-4">Add New Address</h3>
          <div className="space-y-3">
            <div className="flex gap-3">
              <button className="px-4 py-2 rounded-xl border-2 border-primary bg-primary-light text-primary font-medium">Home</button>
              <button className="px-4 py-2 rounded-xl border-2 border-[var(--border)] text-[var(--text-secondary)] hover:border-primary transition-all">Work</button>
              <button className="px-4 py-2 rounded-xl border-2 border-[var(--border)] text-[var(--text-secondary)] hover:border-primary transition-all">Other</button>
            </div>
            <input type="text" placeholder="Address Line 1" className="input-field" />
            <input type="text" placeholder="Address Line 2" className="input-field" />
            <div className="flex gap-3">
              <input type="text" placeholder="City" className="input-field" />
              <input type="text" placeholder="Pincode" className="input-field" />
            </div>
            <input type="tel" placeholder="Phone Number" className="input-field" />
            <label className="flex items-center gap-2 text-sm text-[var(--text)]">
              <input type="checkbox" /> Set as default address
            </label>
            <div className="flex gap-3">
              <button className="btn-primary flex-1">Save Address</button>
              <button onClick={() => setShowAddForm(false)} className="btn-secondary flex-1">Cancel</button>
            </div>
          </div>
        </div>
      )}

      <div className="space-y-4">
        {addresses.map((address) => (
          <motion.div
            key={address.id}
            className="card"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="flex items-start justify-between">
              <div className="flex items-start gap-3">
                {address.type === 'Home' ? <FaHome className="text-primary mt-1" /> : <FaBuilding className="text-primary mt-1" />}
                <div>
                  <h4 className="font-semibold text-[var(--text)]">{address.type} Address</h4>
                  <p className="text-sm text-[var(--text-secondary)]">{address.address}</p>
                  <p className="text-sm text-[var(--text-secondary)]">📱 {address.phone}</p>
                  {address.default && (
                    <span className="badge badge-success text-xs mt-1">✅ Default</span>
                  )}
                </div>
              </div>
              <div className="flex gap-2">
                <button className="text-[var(--text-secondary)] hover:text-primary transition-colors">
                  <FaEdit />
                </button>
                <button onClick={() => handleDelete(address.id)} className="text-[var(--text-secondary)] hover:text-danger transition-colors">
                  <FaTrash />
                </button>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default SavedAddresses;